// extracted by mini-css-extract-plugin
module.exports = {"countdown":"CountDown_countdown__3sNY_","timer":"CountDown_timer__wwUtk","opacity":"CountDown_opacity__1XcIn"};